<template>
    <div>
        <div class="smooth-list">
            <div class="list-header">
                <input type="text" class="form-control" placeholder="Search..." v-model="searchTerm">
            </div>
            <ul class="list">
                <li class="list-item" v-for="item in filteredItems" :class="{active: item.id === activeItemId}" @click.stop="view(item)">
                    <div class="list-item-actions">
                        <button class="btn btn-sm btn-outline dark" :class="{active: item.id === activeItemId && editMode}" @click.stop="edit(item)">
                            <i class="glyphicon glyphicon-pencil"></i>
                        </button>
                    </div>
                    <div class="list-item-info">
                        <div class="item-title" v-text="item.name"></div>
                        <div class="item-slug" v-text="item.slug"></div>
                    </div>
                </li>
                <li class="list-item text-center" @click.stop="create()">
                    <span style="font-size: 1.5em">
                        <i class="glyphicon glyphicon-plus"></i>
                    </span>
                </li>
            </ul>
        </div>

    </div>
</template>

<script>
    export default {
        name: "config-list",

        props: {
            items: {
                required: true,
                type: Array
            },
            activeItem: {
                default: null
            },
            editMode: {
                default: false
            }
        },

        data() {
            return {
                searchTerm: null
            }
        },

        computed: {
            activeItemId() {
                return this.activeItem !== null ? this.activeItem.id : null
            },

            filteredItems() {
                if (!this.searchTerm) {
                    return this.items;
                }

                return _.filter(this.items, (item) => {
                    let searchTerm = _.toLower(this.searchTerm)
                    let name = _.toLower(item.name)
                    let slug = _.toLower(item.slug)

                    return _.includes(name, searchTerm) || _.includes(slug, searchTerm)
                })
            }
        },

        methods: {
            create() {
                this.$emit('create-item')
            },

            edit(item) {
                this.$emit('active-item-changed', {
                    item: item,
                    editMode: true
                })
            },

            view(item) {
                this.$emit('active-item-changed', {
                    item: item,
                    editMode: false
                })
            }
        }
    }
</script>
